import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=b88e9bcc"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b88e9bcc')) {
      api.createRecord('b88e9bcc', component.options)
    } else {
      api.reload('b88e9bcc', component.options)
    }
    module.hot.accept("./Alert.vue?vue&type=template&id=b88e9bcc", function () {
      api.rerender('b88e9bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/Alert.vue"
export default component.exports